import { render, staticRenderFns } from "./ConfirmationPlace.vue?vue&type=template&id=a6ba2ff4&scoped=true&"
import script from "./ConfirmationPlace.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPlace.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPlace.vue?vue&type=style&index=0&id=a6ba2ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ba2ff4",
  null
  
)

export default component.exports